import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const ServicesHero = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section ref={ref} className="relative pt-32 pb-24 bg-gradient-to-br from-[#007dff] via-[#0066dd] to-[#007dff] overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjEiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]"></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-poppins font-bold text-5xl lg:text-7xl text-white mb-6">
            360° Dijital Büyüme Hizmetleri
          </h1>
          <p className="font-poppins text-xl text-white/90 max-w-3xl mx-auto mb-8">
            Sigorta acentenizi dijitalde büyütmek için ihtiyacınız olan her şey
          </p>

          {/* Breadcrumb */}
          <div className="flex items-center justify-center gap-2 text-white/70 font-poppins text-sm">
            <Link to="/" className="hover:text-white transition-colors duration-300">
              Ana Sayfa
            </Link>
            <i className="ri-arrow-right-s-line text-white"></i>
            <span className="text-white">Hizmetler</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesHero;
